import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import * as R from "ramda";
import { Box, Text, Tooltip } from "@chakra-ui/react";

import { TOSModalLinkButton } from "components/TOS/Modal";

const Legalese = ({ children }) => {
  return (
    <Box mt={4} mb={2}>
      <Text fontSize="xs" color="tertiaryText" textAlign="justify" as="div">
        {children}
      </Text>
    </Box>
  );
};

const SecureTokenTooltip = ({ label, tooltip }) => {
  return (
    <Tooltip label={tooltip} aria-label="Tooltip about how secure tokens work">
      <Text textDecoration="underline" display="inline" cursor="help">
        {label}
      </Text>
    </Tooltip>
  );
};

export const AddCCLegalese = () => {
  const { formatMessage } = useIntl();
  const tooltipContent = formatMessage({
    defaultMessage:
      "Our payment service providers replace your payment data with a secure token value that cannot be converted back to payment or account information outside of the payment processing network.",
    description: "tooltip for 'secure token'",
  });
  return (
    <>
      <Legalese>
        <FormattedMessage
          defaultMessage={`By clicking the "Add" button you agree to allow Tilia LLC, its affiliates, and its payment
        processor to save your card information above as a <tooltip>secure token</tooltip> to be used for
        future transactions. Tilia's notification policy can be found in our <a>Terms of Service</a>.`}
          description="Add CC Legalese"
          values={{
            tooltip: (msg) => <SecureTokenTooltip label={msg} tooltip={tooltipContent} />,
            a: (msg) => <TOSModalLinkButton label={msg} size="xs" />,
          }}
        />
      </Legalese>
    </>
  );
};

const needsAttestation = (flow = "") => {
  return R.toLower(flow) === "payout";
};

export const POSLegalese = ({ buttonLabel, flow }) => {
  return (
    <Legalese>
      {needsAttestation(flow) ? (
        <FormattedMessage
          defaultMessage='By clicking the "{buttonLabel}" button, you agree to the <link>Tilia Terms of Service</link> and affirm that you are the owner of the account you have selected above. '
          description="Legal information with a hypertext link"
          values={{
            buttonLabel,
            link: (msg) => <TOSModalLinkButton label={msg} size="xs" />,
          }}
        />
      ) : (
        <FormattedMessage
          defaultMessage='By clicking the "{buttonLabel}" button, you agree to the <link>Tilia Terms of Service</link>. '
          description="Legal information with a hypertext link"
          values={{
            buttonLabel,
            link: (msg) => <TOSModalLinkButton label={msg} size="xs" />,
          }}
        />
      )}
      <span>&nbsp;</span>
      <FormattedMessage
        defaultMessage="Items and services purchased by United States users are sold by Tilia LLC located at 945 Battery Street, San Francisco, CA 94111. Items and services purchased by all other users are sold by Tilia Pay UK Ltd. located at Suite 4, Unit 20 - 22 Grove Trading Estate, Dorchester, England, DT1 1ST."
        description="Legal information."
      />
    </Legalese>
  );
};
